import React from 'react';

import { statBoxes } from '#/components/basic/panels/StatsBoxes';
import { formatNumber, formatUsdWithSign } from '#/lib/display/formatting';
import { useSelector } from '#/reduxState/storeCore';

const { Wrap, BoxAuto, Title, Value } = statBoxes;

export default function MarketsStatsBoxes() {
  const {
    katanaChainVolume24hUsd,
    totalTrades,
    totalVolume,
    totalOpenInterest,
  } = useSelector(state => state.exchange.infoStats);
  return (
    <Wrap>
      <BoxAuto>
        <Title>24h Volume</Title>
        <Value>
          {katanaChainVolume24hUsd
            ? formatUsdWithSign(katanaChainVolume24hUsd, { decimals: 0 })
            : null}
        </Value>
      </BoxAuto>
      <BoxAuto>
        <Title>Open Interest</Title>
        <Value>
          {totalOpenInterest
            ? formatUsdWithSign(totalOpenInterest, { decimals: 0 })
            : null}
        </Value>
      </BoxAuto>
      <BoxAuto>
        {/* TODO: we want 24h Trades instead */}
        <Title>Total Trades</Title>
        <Value>
          {totalTrades ? formatNumber(totalTrades, { fixedDecimals: 0 }) : null}
        </Value>
      </BoxAuto>
      <BoxAuto>
        <Title>All Time Volume</Title>
        <Value>{formatUsdWithSign(totalVolume, { decimals: 0 })}</Value>
      </BoxAuto>
    </Wrap>
  );
}
